import { useQuery } from '@tanstack/react-query';
import { fetchShoppingCartProducts } from './fetchShoppingCartProducts';
import { Pagination } from '../../../models/Pagination';
import { GlobalReactQueryOptions } from '../../config';
import { browserClient } from '../../react-query';
import { ProductFilter } from '../../store/api';

const SHOPPING_CART_PRODUCTS_QUERY_KEY = 'shoppingCartProducts';

interface PropTypes {
    filterMap: ProductFilter;
    pagination: Pagination;
    groupId: string | null | undefined;
    groupType: string;
}
export const useShoppingCartProducts = (props: PropTypes) => {
    const { filterMap, pagination, groupId, groupType } = props;

    const { ...data } = useQuery(
        [
            SHOPPING_CART_PRODUCTS_QUERY_KEY,
            {
                filterMap,
                groupId,
                groupType,
                ...pagination
            }
        ],
        () => fetchShoppingCartProducts({ filterMap, pagination, groupId, groupType }),
        {
            ...GlobalReactQueryOptions
        }
    );
    const { data: shoppingCartProducts } = data;
    return {
        ...data,
        products: {
            count: shoppingCartProducts?.totalHits ?? 0,
            list: shoppingCartProducts?.hits ?? []
        }
    };
};

export const invalidateShoppingCartProducts = () => {
    return browserClient.invalidateQueries({ queryKey: [SHOPPING_CART_PRODUCTS_QUERY_KEY] });
};
